export class FundingCurrencyError extends Error {
    diagnostic;
    constructor(message, diagnostic) {
        super(message);
        this.diagnostic = diagnostic;
        this.name = 'FundingCurrencyError';
    }
}
export function unavailableFundingFx(currency, decimals, fx, now) {
    return {
        event: 'onramp.fx_unavailable',
        currency,
        reason: !Number.isInteger(decimals) || decimals < 0 || decimals > 4
            ? 'invalid_precision'
            : !fx?.ratesD9[currency]
                ? 'missing_rate'
                : Date.parse(fx.expiresAt) <= now
                    ? 'expired_rate'
                    : 'invalid_snapshot',
    };
}
/** Project only known asset codes; provider payloads never enter diagnostic logs. */
export function safeFundingDiagnostic(event) {
    const code = (value) => /^[A-Z]{3}$/.test(value) || value === 'USDC_SOL' ? value : 'unknown';
    return {
        event: event.event,
        reason: event.reason,
        currency: code(event.currency),
        ...(event.providerCurrency !== undefined
            ? { providerCurrency: code(event.providerCurrency) }
            : {}),
    };
}
